import emitter from 'garden/src/js/utils/emitter'

import profile from 'scripts/components/user/profile'

class Resources {
  constructor () {
    this.profile = profile
    this.emitter = emitter
  }

  init () {
    return this.getUserResources()
  }

  getUserResources () {
    return this.profile.get()
      .then(this.onGetUserResourcesSuccess.bind(this))
      .catch(this.onGetUserResourcesFailure.bind(this))
  }

  onGetUserResourcesSuccess (data) {
    this.emitter.emit('user-resources:done', data)

    window.sessionStorage.setItem('userInfo', JSON.stringify({ ...data }))
  }

  onGetUserResourcesFailure (data) {
    this.emitter.emit('user-resources:fail', data)
  }
}

export default () => new Resources().init()

export { Resources as Component }
